export function goToStart() {
  const item = document.getElementById('float-container') || document.getElementById('mobile-wrapper');
  item.scrollTo(0, 0);
  window.scrollTo(0, 0);
}